// extracted by mini-css-extract-plugin
export default {"title":"edit-name-dialog_title__ASy5d","field":"edit-name-dialog_field__umz5f","line":"edit-name-dialog_line__WPkPj","content":"edit-name-dialog_content__yoybO"};